var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _circle3, _circle4, _circle5, _path6, _path7, _path8, _path9, _path10, _circle6, _circle7, _circle8, _circle9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 37H81V48.5",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87 20H70V31.5",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 37,
    r: 6,
    fill: "white",
    stroke: "#333333",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 20,
    r: 6,
    fill: "#F3FAFF",
    stroke: "#333333",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 56.5H20V45",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 80H22V91.5",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72 81L72 98L89 98",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "matrix(-1 0 0 1 26 35)",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 96.5,
    r: 6,
    transform: "rotate(180 22 96.5)",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 98,
    r: 6,
    transform: "rotate(90 95.5 98)",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106 66H93.8904H80",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49 11L49 23.1096L49 37",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60 108L60 95.8904L60 82",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13 68H25.1096H39",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.875 49.415H78.3125V46.5875C78.3125 38.7921 70.3218 31 60.5 31C50.6782 31 42.6875 38.7921 42.6875 46.5875V49.415H39.125C37.2353 49.415 35.4231 50.0108 34.0869 51.0713C32.7507 52.1318 32 53.5702 32 55.07V83.345C32 84.8448 32.7507 86.2832 34.0869 87.3437C35.4231 88.4042 37.2353 89 39.125 89H81.875C83.7647 89 85.5769 88.4042 86.9131 87.3437C88.2493 86.2832 89 84.8448 89 83.345V55.07C89 53.5702 88.2493 52.1318 86.9131 51.0713C85.5769 50.0108 83.7647 49.415 81.875 49.415ZM49.8125 46.5875C49.8125 41.9108 54.6076 38.105 60.5 38.105C66.3924 38.105 71.1875 41.9108 71.1875 46.5875V49.415H49.8125V46.5875ZM64.0625 71.2518V77.69H56.9375V71.2518C54.8178 70.2735 53.375 68.4695 53.375 66.38C53.375 64.8802 54.1257 63.4418 55.4619 62.3813C56.7981 61.3208 58.6103 60.725 60.5 60.725C62.3897 60.725 64.2019 61.3208 65.5381 62.3813C66.8743 63.4418 67.625 64.8802 67.625 66.38C67.625 68.4667 66.1822 70.2706 64.0625 71.2518Z",
    fill: "#A3C5FF",
    stroke: "#333333",
    strokeWidth: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 66,
    r: 6,
    fill: "#A3C5FF",
    stroke: "#333333",
    strokeWidth: 4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 12,
    r: 6,
    transform: "rotate(-90 49 12)",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 109,
    r: 6,
    transform: "rotate(90 60 109)",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "matrix(-1 0 0 1 19 62)",
    fill: "#F3FAFF",
    stroke: "#333333",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.1b6029fe.svg";
export { ForwardRef as ReactComponent };